import { Component, Input, Inject, OnInit } from "@angular/core";
import { PersonDataService } from "../../../core/persons.dataservice";
import { MatDialog } from "@angular/material/dialog";
import { StateService } from "@uirouter/angular";
import { ConfirmDialog } from "../../../shared/confirm-dialog.component";
import * as dataCore from "../../../core/datacore";
import { CrewErrorDialog } from "../../../core/crew-error-dialog.component";

@Component({
    selector: "crew-person",
    template: require('./person.component.html')
})
export class PersonComponent implements OnInit {
    
    @Input()
    person: Nema.Crew.Model.Person;

    public DateOfBirth: Date;

    constructor(
        private stateService: StateService,
        private dialog: MatDialog,
        @Inject(PersonDataService.Id) private personDataService: PersonDataService,
        @Inject('$log') private $log: ng.ILogService) {
    }

    ngOnInit(): void {
        this.DateOfBirth = dataCore.addTimezoneOffset(this.person.DateOfBirth);
    }

    public entityName = "Person";

    public editStateName = "app.resources.persons.edit";

    public listStateName = "app.resources.persons";
    
    public edit(): void {
        this.stateService.go(this.editStateName, { id: this.person.Id });
    }

    public delete(): void {

        var self = this;

        this.dialog
            .open(ConfirmDialog)
            .afterClosed()
            .subscribe(res => self.onDeleteEntity(self, res));
    }

    private onDeleteEntity(self: PersonComponent, shouldDelete?: boolean) {
        if (shouldDelete) {
            self.personDataService
                .delete(self.person)
                .then(() => self.backToList())
                .catch(err => self.handleError(err));
        }
    }

    public backToList(): Promise<any> {
        return this.stateService.go(this.listStateName);
    }

    private handleError(err: any): Promise<void> {
        const errorMessage = "Error deleting " + this.entityName;
        this.$log.error(errorMessage + ".\n\nError is: " + err);

        const dialogRef = this.dialog.open(CrewErrorDialog);
        dialogRef.componentInstance.title = "Error occurred";
        dialogRef.componentInstance.contentStart = errorMessage + ". Check if there are items related to this " + this.entityName + " still in use.";

        let mainContent = err.message ? err.message + "\n\n" : "";
        mainContent += err.longStack || err.stack ? err.longStack || err.stack : err;

        dialogRef.componentInstance.mainContent = mainContent;

        return dialogRef.afterClosed().toPromise().then(() => window.location.reload(true));
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/resources/persons/details/person.component.ts